import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="min-h-[70vh] pt-40 pb-24 max-w-3xl mx-auto px-6 text-center" data-testid="page-not-found">
            <div className="eyebrow mb-6">404</div>
            <h1 className="font-display text-6xl md:text-7xl text-hhc-ink">
                Page not found.
            </h1>
            <p className="mt-6 text-hhc-muted leading-relaxed">
                The room you're looking for doesn't exist. Perhaps we're still
                designing it.
            </p>
            <Link to="/" className="btn-primary text-[13px] mt-10 inline-flex">
                Back home
            </Link>
        </div>
    );
}
